import { googleAnalyticsLib } from 'freedom-shared';

import type { extractAnalyticsDataTypes } from '../analytics-data-extraction';

export const mainPageOpen = () =>
  googleAnalyticsLib.sendEvent('avfree_main_page');

export const submitSearchForm = (
  params: extractAnalyticsDataTypes.ExtractSearchFormDataParams,
) => {
  const mappedSearchFormParams = {
    ...params,
    city_from: params.city_from.code,
    city_to: params.city_to.code,
  };

  googleAnalyticsLib.sendEvent(
    'avfree_search_button_click',
    mappedSearchFormParams,
  );
};
